<template>
    <v-container>
      <v-btn
        color="#4d48f9"
        style="text-transform: none !important; color: white;"
        @click="onBoardingAdd()"
        :disabled="this.allMerchantOnBoardings.length > 3"
        >YENİ SAYFA EKLE</v-btn
      >
      <br />
      <br />
  
      <v-card>
        <v-card-title>
          MerchantApp Welcome Ekranı 
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Ara"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="allMerchantOnBoardings"
          :hide-default-footer="true"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100],
          }"
          :items-per-page="100"
          :search="search"
        >
          <template v-slot:item.description="{ item }">
            <span style="line-break: anywhere;">{{ item.description }}</span>
          </template>
          <template v-slot:item.active="{ item }">
            <v-checkbox
              v-model="item.active"
              color="#4d48f9"
              @change="onBoardingStatusChange(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="onBoardingEdit(item)"
              >mdi-pencil</v-icon
            >
            <!-- <v-icon small @click="onBoardingDelete(item)">mdi-delete</v-icon> -->
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </template>
  
  <script>
  import { mapGetters, mapActions } from "vuex";
  
  export default {
    name: "MerchantOnBoardings",
    data: () => ({
      search: "",
      headers: [
        { text: "Başlık", value: "title", align: "start" },
        { text: "Açıklama", value: "description" },
        { text: "Sıralama", value: "ordering" },
        { text: "Detay", value: "actions", sortable: true },
      ],
    }),
    computed: mapGetters(["allMerchantOnBoardings","loading"]),
    created() {
      this.getMerchantOnBoardings();
    },
    methods: {
      ...mapActions(["getMerchantOnBoardings"]),
      //OnBoardingStatusChange
      onBoardingStatusChange(onBoarding) {
        console.log("onBoardingStatusChange", onBoarding);
      },
      //OnBoardingAdd
      onBoardingAdd() {
        this.$router.push("merchant-onboarding");
      },
      //OnBoardingDetail
      onBoardingEdit(item) {
        this.$router.push(`/dashboard/merchant-onboarding/${item.id}`);
      },
      onBoardingDelete(item) {
        this.deleteOnBoarding(item).then((response) => {
          if (response.data.processStatus == "Success") {
            this.$router.go(0);
          }
        });
      },
    },
  };
  </script>
  
  <style></style>
  